import { Record as record } from 'immutable';

import config from '../../../../src/config';
import Customer from '../delayRepay/Customer';
import Ticket from '../delayRepay/Ticket';
import Journey from '../delayRepay/Journey';
import Delay from '../delayRepay/Delay';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';
import { construct, resolve, fields } from '../../../../src/helpers/LinkMapper';

const claimIdParser = (claimRef) => claimRef && claimRef.toString().replace(/\D/g, '');

const fieldSchema = {
    id: [ resolve.with(claimIdParser) ],
    claimRef: [ fields.string ],
    customer: [ resolve.as(Customer) ],
    ticket: [ resolve.as(Ticket) ],
    journey: [ resolve.as(Journey) ],
    delay: [ resolve.as(Delay) ],
    compensationAmount: [ fields.number ]
};

export default class DelayRepayClaim extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        json.id = json.id || json.claimRef;
        return construct(DelayRepayClaim, json, getResolvers(fieldSchema));
    }

    get expiryDate () {
        const dateTime = this.journey.departureDateTime.clone();
        const maxDays = config.get('delayRepayMaxTicketDays');
        return dateTime && dateTime.add(maxDays, 'days');
    }

    get hasExpired () {
        return this.expiryDate.isBefore();
    }
}
